export default __webpack_public_path__ + "static/media/Print-03.6ebdd52f.svg";